









































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import EditorOption from '@/components/question-editor/EditorOption.vue';
import extentions from '@/components/question-editor/editor-extensions/editor-extensions';
import getModifiedJson from '@/components/question-editor/editor-output/get-modified-json';
import { BuildQuestion } from '@/utils/add-question/add-question-util';
import { PdfHtml, QuestionHtml } from '@/resource/question/question.model';
import { getMainLanguage } from '@/components/question-editor/question-editor-util';
import { QuestionLanguage } from '@/resource/subject/subject.model';

@Component({
  components: { EditorContent, EditorOption },
})
export default class EditorMain extends Vue {
  editorVersion = '1.0.0';

  @Prop()
  buildQuestion!: BuildQuestion;

  editor: null | Editor = null;
  outputHtmls: QuestionHtml[] = [];
  outputAnswerHtmls: PdfHtml[] = [];
  isOutputLoading = false;
  isLoading = true;

  editorExtenstions = [
    StarterKit.configure({ listItem: false }),
    ...extentions,
  ];

  get selectedLanguages() {
    return this.buildQuestion.languages;
  }

  get mainLanguage() {
    return getMainLanguage(this.buildQuestion.languages);
  }

  getMainLanguageByLanguages(languages: QuestionLanguage[]) {
    return getMainLanguage(languages);
  }

  async mounted() {
    this.isLoading = true;
    this.isOutputLoading = true;

    const getOutput = this.getOutput;

    this.editor = new Editor({
      extensions: this.editorExtenstions,
      content: this.buildQuestion.questionJson || null,
      onCreate: async () => {
        await getOutput();
      },
    });

    this.isLoading = false;
    this.isOutputLoading = false;
  }

  async getOutput() {
    this.isOutputLoading = true;

    if (this.editor) {
      const orignalJson = this.editor.getJSON();

      this.buildQuestion.questionJson = orignalJson;
      this.buildQuestion.buildJson = null;

      const questionJsons = await getModifiedJson(
        orignalJson,
        this.buildQuestion.languages,
        true,
      );

      const pdfJsons = await getModifiedJson(
        orignalJson,
        this.buildQuestion.languages,
        false,
      );

      const questionHtmls: QuestionHtml[] = [];
      const pdfHtmls: PdfHtml[] = [];

      questionJsons.forEach(newJson => {
        const questionEditor = new Editor({
          extensions: this.editorExtenstions,
          content: newJson.newJson,
        });

        const questionHtml = questionEditor.getHTML();

        questionHtmls.push({
          languages: newJson.languages,
          question: questionHtml,
        });
      });

      pdfJsons.forEach(newJson => {
        const questionEditor = new Editor({
          extensions: this.editorExtenstions,
          content: newJson.newJson,
        });

        const answerEditor = new Editor({
          extensions: this.editorExtenstions,
          content: newJson.answerJson,
        });

        const questionHtml = questionEditor.getHTML();
        const answerHtml = answerEditor.getHTML();

        pdfHtmls.push({
          languages: newJson.languages,
          question: questionHtml,
          answer: answerHtml,
        });
      });

      this.outputHtmls = questionHtmls;
      this.outputAnswerHtmls = pdfHtmls;

      this.buildQuestion.questionHtmls = questionHtmls;
      this.buildQuestion.pdfHtmls = pdfHtmls;
      this.buildQuestion.editorVersion = this.editorVersion;
    }
    this.isOutputLoading = false;
  }
}
